module.exports = __webpack_public_path__ + "static/media/gptzero.2317fe89.png";